import { kea } from 'kea'
import PropTypes from 'prop-types'

export default kea({
  actions: () => ({
    setOfflineToggleMode: true
  }),

  reducers: ({ actions }) => ({
    offlineToggleMode: [
      false,
      PropTypes.bool,
      {
        [actions.setOfflineToggleMode]: (state, _) => !state
      }
    ]
  })
})
